import React, { useEffect } from 'react';
import useScrollProgress from '@polestar/component-warehouse-react/components/parallax/useScrollProgress';
import useResizeCallback from '@polestar/component-warehouse-react/hooks/useResizeCallback';
import useCombinedRef from '@polestar/component-warehouse-react/hooks/useCombinedRef';
import styled from '@emotion/styled';
import framesync from 'framesync';
import { m as motion } from 'framer-motion';
export const ScrolledPassedHelper = ({ offsetRef, passed, ...props }) => {
    const { scrollProgressRef, progress } = useScrollProgress();
    const callbackRef = useResizeCallback((node) => {
        if (node) {
            const currentScrollTop = (document.documentElement || document.body).scrollTop;
            // @ts-ignore
            offsetRef.current = Math.round(node.getBoundingClientRect().top + currentScrollTop);
        }
    }, [offsetRef]);
    const ref = useCombinedRef(callbackRef, scrollProgressRef);
    useEffect(() => progress.on('change', (latestProgress) => {
        const newValue = latestProgress >= 1;
        if (passed.get() !== newValue) {
            framesync.render(() => {
                passed.set(newValue);
            }, false, true);
        }
    }), [passed, progress]);
    return React.createElement(MeasureHelper, { ref: ref, ...props });
};
const MeasureHelper = styled(motion.div) `
  position: relative;
  height: 0 !important;
  flex-grow: 0;
`;
